import { render, staticRenderFns } from "./IconSvgCategories.vue?vue&type=template&id=1e3068e0&scoped=true&"
import script from "./IconSvgCategories.vue?vue&type=script&lang=js&"
export * from "./IconSvgCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3068e0",
  null
  
)

export default component.exports